module.exports = __webpack_public_path__ + "img/johnston-logo.ed75c62a.png";